import { imageUrl } from '@helpers/image';
import * as React from 'react';
import AnnualReportCta from './AnnualReportCta/AnnualReportCta';
import S from './Footer.styles';
import FooterLinks from './FooterLinks/FooterLinks';
import LegalLinks from './LegalLinks/LegalLinks';
import SocialLinks from './SocialLinks/SocialLinks';
const Footer = ({ copyright, footerLogo, footerLogoAltText, footerLogo2, footerLogo2Cta, legal, legalLinks, links1, links2, links3, reportCta1, reportCta2, reportImage, social, }) => {
    let linksCount = 0;
    if (links1) {
        linksCount++;
    }
    if (links2) {
        linksCount++;
    }
    if (links3) {
        linksCount++;
    }
    return (React.createElement(S.Container, { "data-links": linksCount },
        React.createElement(S.Inner, null,
            React.createElement(S.LogoWrapper, null,
                footerLogo && (React.createElement(S.LogoLink, { href: "/" },
                    React.createElement(S.LogoImage, { alt: footerLogoAltText, loading: "lazy", src: imageUrl({ src: footerLogo }, { height: 142 }) }))),
                footerLogo2 && (React.createElement(S.LogoLink, { href: footerLogo2Cta ? footerLogo2Cta.url : '/', target: footerLogo2Cta ? footerLogo2Cta.target : '_self' },
                    React.createElement(S.LogoImage, { alt: footerLogo2Cta ? footerLogo2Cta.text : '', loading: "lazy", src: imageUrl({ src: footerLogo2 }, { height: 142 }) })))),
            (links1 || links2 || links3) && (React.createElement(S.LinksWrapper, null,
                links1 && React.createElement(FooterLinks, { items: links1, label: "Footer Links 1" }),
                links2 && React.createElement(FooterLinks, { items: links2, label: "Footer Links 2" }),
                links3 && React.createElement(FooterLinks, { items: links3, label: "Footer Links 3" }))),
            (reportCta1 || reportCta2) && (React.createElement(AnnualReportCta, { cta1: reportCta1, cta2: reportCta2, image: reportImage })),
            social && React.createElement(SocialLinks, { items: social, label: "Social Links" }),
            legal && React.createElement(S.LegalStatement, { dangerouslySetInnerHTML: { __html: legal } }),
            legalLinks && React.createElement(LegalLinks, { items: legalLinks, label: "Legal Links" }),
            copyright && React.createElement(S.Copyright, { dangerouslySetInnerHTML: { __html: copyright } }))));
};
export default Footer;
